import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import LogoImg from '../images/common/logo.svg';

function FooterNav() {
  return (
    <ul className="footer-nav">
      <li className="pc footer-nav__item"><Link to="/about">くじフェス！とは</Link></li>
      <li className="footer-nav__item"><a href="https://goodroid.co.jp/policy/" target="_blank" rel="noopener noreferrer">個人情報保護方針</a></li>
      <li className="pc footer-nav__item"><Link to="/faq">よくあるご質問</Link></li>
      <li className="pc footer-nav__item"><a href="/#/contact">お問い合わせ</a></li>
      <li className="footer-nav__item"><Link to="/notes">注意事項</Link></li>
      <li className="footer-nav__item"><Link to="/policy">特定商取引法表示</Link></li>
      <li className="footer-nav__item"><a href="https://goodroid.co.jp/" target="_blank" rel="noopener noreferrer">運営会社</a></li>
    </ul>
  );
}

function Copyright() {
  return (
    <div>
      <div className="footer-logo">
        <Link to="/">
          <img src={LogoImg} alt="くじフェス！" />
        </Link>
      </div>
      <p className="copyright">Copyright (c) 2019 GOODROID all rights reserved.</p>
    </div>
  );
}

class Footer extends Component {
  render() {
    return (
      <footer className="footer">
        <div className="footer-inner">
          <FooterNav />
          <Copyright />
        </div>
      </footer>
    );
  }
}
export default Footer;